module.exports = "/_next/static/images/30-1-f7a2dcbef4d617bec2fc4b7a50fd342d.jpg";